import { render, staticRenderFns } from "./AddressValidationStatus.vue?vue&type=template&id=888687d0&scoped=true"
import script from "./AddressValidationStatus.vue?vue&type=script&setup=true&lang=ts"
export * from "./AddressValidationStatus.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./AddressValidationStatus.vue?vue&type=style&index=0&id=888687d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "888687d0",
  null
  
)

export default component.exports